import isEmpty from 'lodash/isEmpty'
import VueLazyLoad from 'vue3-lazyload'
import { createMetaManager, defaultConfig } from 'vue-meta'
import { defineAsyncComponent } from 'vue'

import "~/scss/tailwind.scss";
import "~/scss/theme.scss";
import "~/scss/styles.scss";

import LayoutDefault from '~/core/components/templates/layouts/default/default.vue'
import LayoutFullWidth from '~/core/components/templates/layouts/fullWidth/fullWidth.vue'

const HelpLoader = () => import('~/core/components/extensions/common/help/help.vue')
const Help = defineAsyncComponent(HelpLoader)

const AccountLoader = () => import('~/core/components/extensions/account/account/account.vue')
const Account = defineAsyncComponent(AccountLoader)

const AccountLinksLoader = () => import('~/core/components/extensions/account/account-links/account-links.vue')
const AccountLinks = defineAsyncComponent(AccountLinksLoader)

const BlogCategoryLoader = () => import('~/core/components/extensions/blog/category/category.vue')
const BlogCategory = defineAsyncComponent(BlogCategoryLoader)

const LatestPostLoader = () => import('~/core/components/extensions/blog/latest-post/latest-post.vue')
const LatestPost = defineAsyncComponent(LatestPostLoader)

const SearchPostLoader = () => import('~/core/components/extensions/blog/search-post/search-post.vue')
const SearchPost = defineAsyncComponent(SearchPostLoader)

const SearchProductLoader = () => import('~/core/components/extensions/store/search-product/search-product.vue')
const SearchProduct = defineAsyncComponent(SearchProductLoader)

const LatestProductLoader = () => import('~/core/components/extensions/store/latest-product/latest-product.vue')
const LatestProduct = defineAsyncComponent(LatestProductLoader)

const SpecialProductLoader = () => import('~/core/components/extensions/store/special-product/special-product.vue')
const SpecialProduct = defineAsyncComponent(SpecialProductLoader)

const RelatedProductLoader = () => import('~/core/components/extensions/store/related-product/related-product.vue')
const RelatedProduct = defineAsyncComponent(RelatedProductLoader)

const NewRelatedProductLoader = () => import('~/core/components/extensions/store/new-related-product/new-related-product.vue')
const NewRelatedProduct = defineAsyncComponent(NewRelatedProductLoader)

const FeaturedProductLoader = () => import('~/core/components/extensions/store/featured-product/featured-product.vue')
const FeaturedProduct = defineAsyncComponent(FeaturedProductLoader)

const HomeTopHeaderLoader = () => import('~/core/components/extensions/common/home-top-header/home-top-header.vue')
const HomeTopHeader = defineAsyncComponent(HomeTopHeaderLoader)

const HomeCenterLoader = () => import('~/core/components/extensions/common/home-center/home-center.vue')
const HomeCenter = defineAsyncComponent(HomeCenterLoader)

const HomeBottomLoader = () => import('~/core/components/extensions/common/home-bottom/home-bottom.vue')
const HomeBottom = defineAsyncComponent(HomeBottomLoader)

const SlideshowLoader = () => import('~/core/components/extensions/common/slideshow/slideshow.vue')
const Slideshow = defineAsyncComponent(SlideshowLoader)

const PoliciesLinksLoader = () => import('~/core/components/extensions/common/policies-links/policies-links.vue')
const PoliciesLinks = defineAsyncComponent(PoliciesLinksLoader)

const AboutUsLoader = () => import('~/core/components/extensions/common/about-us/about-us.vue')
const AboutUs = defineAsyncComponent(AboutUsLoader)

const PagesLoader = () => import('~/core/components/extensions/common/pages/pages.vue')
const Pages = defineAsyncComponent(PagesLoader)

const StoreCategoryLoader = () => import('~/core/components/extensions/store/category/category.vue')
const StoreCategory = defineAsyncComponent(StoreCategoryLoader)

const ExtraLinksLoader = () => import('~/core/components/extensions/common/extra-links/extra-links.vue')
const ExtraLinks = defineAsyncComponent(ExtraLinksLoader)

const CheckoutLoader = () => import('~/../checkout-app/lib/components/extensions/checkout/checkout.vue')
const Checkout = defineAsyncComponent(CheckoutLoader)

const NewCheckoutLoader = () => import('~/../checkout-app/lib/components/extensions/new-checkout/new-checkout.vue')
const NewCheckout = defineAsyncComponent(NewCheckoutLoader)

const MenuLoader = () => import('~/core/components/extensions/common/menu/menu.vue')
const Menu = defineAsyncComponent(MenuLoader)

const SearchLoader = () => import('~/core/components/extensions/common/search/search.vue')
const Search = defineAsyncComponent(SearchLoader)

const SelectedProductsLoader = () => import('~/core/components/extensions/store/selected-products/selected-products.vue')
const SelectedProducts = defineAsyncComponent(SelectedProductsLoader)

const CheckoutTopHeaderLoader = () => import('~/core/components/extensions/common/checkout-top-header/checkout-top-header.vue')
const CheckoutTopHeader = defineAsyncComponent(CheckoutTopHeaderLoader)


// Home is server-rendered from four position extensions. If their async
// wrappers are still unresolved when Vue starts hydration, Vue temporarily
// replaces the complete SSR modules with empty async placeholders. On a cold,
// throttled load that collapses the whole Home document before the chunks
// resolve, producing a catastrophic CLS. Warm the wrappers before mount so
// hydration adopts the existing DOM without an empty intermediate frame.
const initialHomeExtensionComponents = []

initialHomeExtensionComponents.push(HomeTopHeader)
initialHomeExtensionComponents.push(HomeCenter)
initialHomeExtensionComponents.push(HomeBottom)
initialHomeExtensionComponents.push(SelectedProducts)

const baseURL = typeof document !== "undefined"
? 'https://hooliganseyewear.com/index.php?route=extension/module/d_vuefront/graphql&cors=false'
: 'https://hooliganseyewear.com/index.php?route=extension/module/d_vuefront/graphql&cors=false'

export default async (ctx, inject) => {
  const metaManager = createMetaManager(
    typeof document === "undefined",
    {
      ...defaultConfig,
      robots: { tag: "meta" },
      keyword: { tag: "meta" },
      keywords: { tag: "meta" },
    }
  )
  ctx.app.use(metaManager)
  ctx.app.use(VueLazyLoad, {
    throttleWait: 10000
  })

  const images = {}

  

  images.placeholder = {}
  images.placeholder.image = await import('~/assets/img/placeholder.png?url');
  images.placeholder.image = images.placeholder.image.default
  

  images.logo = {}
  images.logo.width = 180;
  images.logo.height = 40;

  images.product = {}
  images.product.width = 825;
  images.product.height = 825;

  images.categoryThumb = {}
  images.categoryThumb.width = 300;
  images.categoryThumb.height = 300;

  images.productThumb = {}
  images.productThumb.width = 300;
  images.productThumb.height = 300;

  images.productThumbInline = {}
  images.productThumbInline.width = 200;
  images.productThumbInline.height = 200;

  images.post = {}
  images.post.width = 825;
  images.post.height = 495;

  images.postThumb = {}
  images.postThumb.width = 300;
  images.postThumb.height = 180;

  images.postThumbInline = {}
  images.postThumbInline.width = 200;
  images.postThumbInline.height = 120;

  images.contact = {}
  images.contact.width = 200;
  images.contact.height = 120;

  
  ctx.app.component('VfTLayoutDefault', LayoutDefault);
  ctx.app.component('VfTLayoutFullWidth', LayoutFullWidth);
  
  ctx.app.component('VfEHelp', Help);
  ctx.app.component('VfEAccount', Account);
  ctx.app.component('VfEAccountLinks', AccountLinks);
  ctx.app.component('VfEBlogCategory', BlogCategory);
  ctx.app.component('VfELatestPost', LatestPost);
  ctx.app.component('VfESearchPost', SearchPost);
  ctx.app.component('VfESearchProduct', SearchProduct);
  ctx.app.component('VfELatestProduct', LatestProduct);
  ctx.app.component('VfESpecialProduct', SpecialProduct);
  ctx.app.component('VfERelatedProduct', RelatedProduct);
  ctx.app.component('VfENewRelatedProduct', NewRelatedProduct);
  ctx.app.component('VfEFeaturedProduct', FeaturedProduct);
  ctx.app.component('VfEHomeTopHeader', HomeTopHeader);
  ctx.app.component('VfEHomeCenter', HomeCenter);
  ctx.app.component('VfEHomeBottom', HomeBottom);
  ctx.app.component('VfESlideshow', Slideshow);
  ctx.app.component('VfEPoliciesLinks', PoliciesLinks);
  ctx.app.component('VfEAboutUs', AboutUs);
  ctx.app.component('VfEPages', Pages);
  ctx.app.component('VfEStoreCategory', StoreCategory);
  ctx.app.component('VfEExtraLinks', ExtraLinks);
  ctx.app.component('VfECheckout', Checkout);
  ctx.app.component('VfENewCheckout', NewCheckout);
  ctx.app.component('VfEMenu', Menu);
  ctx.app.component('VfESearch', Search);
  ctx.app.component('VfESelectedProducts', SelectedProducts);
  ctx.app.component('VfECheckoutTopHeader', CheckoutTopHeader);

  if (
    typeof window !== 'undefined' &&
    window.location.pathname === '/' &&
    initialHomeExtensionComponents.length
  ) {
    await Promise.all(
      initialHomeExtensionComponents.map(component => component.__asyncLoader())
    )
  }

  const extensions = {}

  
  extensions.Help = HelpLoader;
  extensions.Account = AccountLoader;
  extensions.AccountLinks = AccountLinksLoader;
  extensions.BlogCategory = BlogCategoryLoader;
  extensions.LatestPost = LatestPostLoader;
  extensions.SearchPost = SearchPostLoader;
  extensions.SearchProduct = SearchProductLoader;
  extensions.LatestProduct = LatestProductLoader;
  extensions.SpecialProduct = SpecialProductLoader;
  extensions.RelatedProduct = RelatedProductLoader;
  extensions.NewRelatedProduct = NewRelatedProductLoader;
  extensions.FeaturedProduct = FeaturedProductLoader;
  extensions.HomeTopHeader = HomeTopHeaderLoader;
  extensions.HomeCenter = HomeCenterLoader;
  extensions.HomeBottom = HomeBottomLoader;
  extensions.Slideshow = SlideshowLoader;
  extensions.PoliciesLinks = PoliciesLinksLoader;
  extensions.AboutUs = AboutUsLoader;
  extensions.Pages = PagesLoader;
  extensions.StoreCategory = StoreCategoryLoader;
  extensions.ExtraLinks = ExtraLinksLoader;
  extensions.Checkout = CheckoutLoader;
  extensions.NewCheckout = NewCheckoutLoader;
  extensions.Menu = MenuLoader;
  extensions.Search = SearchLoader;
  extensions.SelectedProducts = SelectedProductsLoader;
  extensions.CheckoutTopHeader = CheckoutTopHeaderLoader;
  
  inject('vuefront', {
    layouts: {"*":{"headerMenu":[["Menu",{"items":["store","blog"]}]],"footer1":["AboutUs"],"footer2":[["ExtraLinks",{"links":[{"to":"/contact","text":"Contact Us"}]}]],"footer3":["PoliciesLinks"],"footer4":["Help"]},"/":{"contentFullTop":[],"contentTop":["HomeTopHeader","SelectedProducts","HomeCenter"],"contentBottom":["HomeBottom"]},"/about_us":{"contentBottom":["HomeBottom"]},"/refund_policy":{"contentBottom":["HomeBottom"]},"/delivery":{"contentBottom":["HomeBottom"]},"/terms":{"contentBottom":["HomeBottom"]},"/customer_care":{"contentBottom":["HomeBottom"]},"/privacy_policy":{"contentBottom":["HomeBottom"]},"/cookies_policy":{"contentBottom":["HomeBottom"]},"/payment_methods":{"contentBottom":["HomeBottom"]},"/size_guide":{"contentBottom":["HomeBottom"]},"/store/category*":{"contentBottom":["HomeBottom"]},"/blog/category*":{"columnRight":["BlogCategory"]},"/store/product/*":{"contentBottom":["HomeBottom"]},"/blog/post*":{"columnRight":[["LatestPost",{"column":true}]]},"/account*":{},"/store/checkout":{"contentTop":["CheckoutTopHeader"],"contentBottom":["NewCheckout","HomeBottom"]}},
    extensions,
    templates: {},
    baseURL,
    images,
    version: {"api":"1.0.0"},
    options: {"productGridSize":9,"productGridSizeTablet":2,"productGridNoGutters":false},
    get isAuth() {
      return ctx.$store.getters['common/customer/auth']
    },
    async logout() {
      await ctx.$store.dispatch('common/customer/logout')
      
      ctx.$router.push("/account/login");
    },
    get isClient() {
      return typeof document !== "undefined"
    },
    get params() {
      let result = ctx.$route.value.params

      if(!isEmpty(ctx.$route.value.matched)) {
        result = {...result, ...ctx.$route.value.matched[0].props.default}
      }

      return result
    },
    get isMobile() {

      var isMobile = false;
      if (typeof window !== "undefined") {
        isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
      } else if(!isUndefined(ctx.req) && !isUndefined(ctx.req.headers)) {
        // if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(ctx.req.headers['user-agent']) 
        //   || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ctx.req.headers['user-agent'].substr(0,4))) { 
          // isMobile = true;
        // }
      }
      return isMobile
    },
    get isAMP() {
      return /^\/amp([\/].*)?$/gi.test(ctx.$route.fullPath)
    }
  })

}
